import { BehaviorSubject, combineLatest, ReplaySubject } from "rxjs";
import { ServiceProvider } from "@sa/rep-services-provider";
import { MapDataGroup, MapDataSource, MapDataSourceId } from "../models/MapDataSource";
import { MapDimension } from "../models/MapDimension";
import { MapDataCountry } from "../models/MapDataCountry";
import { MapAPIService } from "../services/MapAPIService";
import { ServicesMaps } from "../MapReportingProvider";
import { orderBy } from "lodash";
import { FavouriteMapItem } from "../../favourites/types";

export class MapStore {
  private _mapApi: MapAPIService;

  favouriteItem$ = new BehaviorSubject<FavouriteMapItem | undefined>(undefined);
  loadingData$ = new BehaviorSubject<boolean>(true);
  data$ = new ReplaySubject<Map<string, MapDataCountry>>(1);
  loadingDataSources$ = new BehaviorSubject<boolean>(true);
  loadingDimensions$ = new BehaviorSubject<boolean>(true);
  dataSourceId$ = new BehaviorSubject<MapDataSourceId>(MapDataSourceId.HarmonizedDataset);
  dataSource$ = new ReplaySubject<MapDataSource>(1);
  dataSources$ = new ReplaySubject<(MapDataSource | MapDataGroup)[]>(1);
  dimensions$ = new ReplaySubject<MapDimension[]>(1);
  dimensionsValues = new Map<number, ReplaySubject<unknown>>();

  refresh = () => {
    this.dataSourceId$.next(MapDataSourceId.HarmonizedDataset);
  };

  constructor(private serviceProvider: ServiceProvider) {
    this._mapApi = this.serviceProvider.resolve<MapAPIService>(ServicesMaps.MapAPI);

    combineLatest([this.dataSourceId$, this.dataSources$]).subscribe(async ([dataSourceId, dataSources]) => {
      const dataSource = dataSources.find((e) => e.id === dataSourceId);
      const dimensionsPrms = this._mapApi.getDataSourceDimensions(dataSourceId);
      if (dataSource) {
        this.dataSource$.next(dataSource as MapDataSource);
        this.loadingData$.next(true);
        this.loadingDimensions$.next(true);
        // this.dimensions$.next([]);
        const dimensions = await dimensionsPrms;
        dimensions.forEach((e) => {
          e.dataSource = dataSource as MapDataSource;
          if (!this.dimensionsValues.has(e.id)) {
            this.dimensionsValues.set(e.id, new ReplaySubject(1));
          }
        });
        this.dimensions$.next(orderBy(dimensions, (e) => e.order));
        this.loadingDimensions$.next(false);
      }
    });
  }

  async fetchDataSources() {
    this.loadingData$.next(true);
    this.loadingDataSources$.next(true);
    const dataSources = await this._mapApi.getDataSources();
    this.dataSources$.next(
      orderBy(dataSources, (e) => {
        if (e instanceof MapDataGroup && e.group) {
          return e.group;
        }
        return e.id;
      })
    );
    this.loadingDataSources$.next(false);
  }
}
